import { Book } from 'lucide-react'

import { IconActionButton, IconActionButtonProps } from './icon-action-button'

const Component = (props: IconActionButtonProps) => (
  <IconActionButton
    icon={Book}
    tooltip="Nova regra"
    aria-label="Adicionar"
    {...props}
  />
)

export default Component
